import React from 'react';
import type { DetailedProxyMetadata } from 'venn-api';
import { cn } from '@/lib/utils';
import type { FundToBulkProxy, FundToProxy } from '../../types';

const SingleInvestmentInfo = ({
  investment,
  proxyData,
}: {
  investment: FundToProxy | FundToBulkProxy;
  proxyData: DetailedProxyMetadata | undefined;
}) => {
  return (
    <div className={cn('p-[9px] bg-gray-100 flex gap-[12px] justify-between qa-existing-proxy')}>
      <div>
        <div className={cn('font-bold mb-[6px]')}>Asset Name</div>
        <div>{investment.name}</div>
      </div>

      {proxyData && (
        <div>
          <div className={cn('font-bold mb-[6px]')}>Existing Holdings Proxy</div>
          <div>{proxyData?.proxyName}</div>
        </div>
      )}
    </div>
  );
};

export default SingleInvestmentInfo;
